// ============================================================================
// ShellComponent - Main App Layout (Header + Nav + Content + Right Panel)
// ============================================================================
// Wraps all authenticated routes. On init, triggers initialDataLoad via
// SessionService then calculates permissions. Replaces V1's master layout
// partial and the angData initialization in app.js run block.
// ============================================================================

import { Component, OnInit } from '@angular/core';
import { SessionService } from '../core/session.service';
import { PermissionsService } from '../core/permissions.service';
import { AuthService } from '../core/auth.service';
import { LoadingService } from '../core/loading.service';

@Component({
  standalone: false,
  selector: 'app-shell',
  templateUrl: './shell.component.html',
  styleUrls: ['./shell.component.scss']
})
export class ShellComponent implements OnInit {
  loading = true;
  showLoading = false;

  constructor(
    public session: SessionService,
    public perms: PermissionsService,
    public auth: AuthService,
    private loadingSvc: LoadingService
  ) {}

  ngOnInit(): void {
    // Load all initial data after login
    this.session.loadInitialData().then(() => {
      this.perms.calculate();
      this.loading = false;
    }).catch((err) => {
      console.error('[SHELL] initialDataLoad failed:', err);
      // Don't auto-logout during dev - just show the error
      this.loading = false;
    });

    // Track HTTP loading state
    this.loadingSvc.onLoadingChanged.subscribe(isLoading => {
      this.showLoading = isLoading;
    });
  }
}
